import { DateRange } from 'react-day-picker';

export type DatePickerProps = {
  finalRange: DateRange | undefined;
  handleApply: (selectedRange: DateRange) => void;
  mode: string;
  className?: string;
};

export type DateSelectorProps = {
  selectedDate: DateRange | undefined;
  setSelectedDate: (dateRange: DateRange | undefined) => void;
  setShowDatePicker: (show: boolean) => void;
  handleApply: (dateRange: DateRange) => void;
  handleCancel: () => void;
  showDatePicker: boolean;
  buttonClass?: string;
  maxDate: moment.Moment;
  minDate: moment.Moment;
  setMonth: Function;
  month: Date | null | undefined;
  wholeMonth: boolean;
  setWholeMonth: Function;
  mode?: string;
  className?: string;
  position?: 'left' | 'right';
};

export enum Mode {
  Range = 'range',
  Single = 'single',
}
